import { AlertWrapper } from '@anm/components/notification/Alert';
import { flexCenter, flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${AlertWrapper} {
    ${flexRow};
    color: #292a2b;
    font-size: 16px;
    margin: 40px 30px;
    justify-content: space-between;
  }
`;

const upgradeBlockOnMobile = media.phone`
 p {
   ${flexColumn}
 }
`;

export const UpgradeBlock = styled.div`
  ${flexCenter};
  font-size: 14px;
  min-height: 71px;
  p {
    ${flexCenter};
    color: #292a2b;
  }
  a {
    color: var(--blue_100);
  }
  ${upgradeBlockOnMobile};
`;

export const ChargePrices = styled.span`
  text-align: end;
`;
